// v1.0.0
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import Router from 'vue-router'
import routes from './routes'
import * as Cookies from 'js-cookie'
import { getRoomInfo } from './util'
import axios from 'axios'

window.axios = axios

/* ------------------------------ legary code ------------------------------ */

/* for eslint ignore */
/* global is_login user_count chattingApp */

/* eslint camelcase: 0 */
/* eslint no-undef: 0 */
/* eslint no-native-reassign: 0 */
/* eslint no-global-assign: 0 */
/* eslint no-unused-vars: 0 */
/* eslint comma-dangle: 0 */

// 브라우저 타입
window.getUserAgent = function () {
  if (navigator.userAgent.indexOf('MSIE') !== -1) {
    return 'IE'
  }
  if (navigator.userAgent.indexOf('Firefox') !== -1) {
    return 'FF'
  }
  if (navigator.userAgent.indexOf('Mozilla') !== -1) {
    return 'MZ'
  }
  if (navigator.userAgent.indexOf('Opera') !== -1) {
    return 'OP'
  }
  if (navigator.userAgent.indexOf('Safari') !== -1) {
    return 'SF'
  }
  if (navigator.userAgent.indexOf('Mac') !== -1) {
    return 'MC'
  }
  return 'NG' // 지원하지 않는 브라우저
}

// 스크립트 전역변수
window.winOneToOne = null // 1:1 사용자의 윈도우 객체.
window.winChat = null // 채팅 윈도우 객체.
window.max_reconnect_time = 0
window.reconnect_yn = false // 재접속을 해야할지 유무
window.is_login = false // 접속중인지 여부
window.is_login_success = false // 로그인 성공여부
window.queue = []
window.session_id = Cookies.get('PHPSESSID')

window.channel_names = { 'localhost': '스포츠 채팅', 'game': '사다리 채팅', 'esports': '다리다리 채팅', 'racing': '미니게임 채팅', 'heroes': '일레븐히어로즈 채팅', 'fireworks': '불꽃놀이 채팅', 'fxgame': 'FX게임 채팅', 'lottery': '파워볼' }
window.channel_name = channel_names[window.site_id]
window.is_freeze = false
window.room_uid = ''
window.opener_id = ''
window.opener_name = ''
window.room_info = {}
window.user_count = 0
window.allow_whisper = 'N'
window.user_status = 'normal'
window.memo_sound = 'Y'
window.invite_sound = 'Y'
window.chatlog = []
window.browser_type = getUserAgent()
window.enable_flash = true // 플래시 플레이어 로드 여부
window.use_browser_ws = false // 브라우져의 웹소켓 사용 여부
window.ws = {} // websocket object
window.ws_sub = {} // websocket sub object
window.flash_ws = {} // flash websocket object
window.is_chrome = !!window.chrome

window.is_ie10 = navigator.userAgent.indexOf('Trident/6.0') > 0
window.is_ie11 = navigator.userAgent.indexOf('Trident/7.0') > 0

if (navigator.userAgent.indexOf('Android') > 0) {
  use_browser_ws = true
}

if (deviceType === 'iphone') {
  window.use_browser_ws = true
}

if (browser === 'Safari') {
  use_browser_ws = true
  enable_flash = false
} else if (browser === 'Firefox' && parseInt(browser_version) > 17) {
  use_browser_ws = true
  enable_flash = false
} else if (is_chrome) {
  use_browser_ws = true
  enable_flash = false
}

// IE 10,11 은 websocket 지원
if ((is_ie11 || is_ie10) && ('WebSocket' in window)) {
  use_browser_ws = true
} else {
  if (use_browser_ws === true) { // 웹소켓 객체 확인
    if (typeof (WebSocket) !== 'function' || window.WebSocket || ('WebSocket' in window)) {
      use_browser_ws = true
    } else {
      use_browser_ws = false
    }
  }
}

// level과 성별에 따라 얼굴 아이콘을 다르게 설정한다.
if (level === 'GUEST') {
  face_icon = (gender === 'F') ? 'guest2.gif' : 'guest1.gif'
} else {
  face_icon = (gender === 'F') ? '2.gif' : '1.gif'
}

// 레벨에 따라 face_icon을 설정한다.
window.init = function () {
  if (!is_allow_guest && member_no === '') {
    printNotifyMessage('손님은 로그인후 채팅에 참여할수 있습니다.')
    return false
  }

  if (use_browser_ws) {
    connect()
    cheerConnect()
  }
}

window.connect = function (not_disp_info, isReconnect, calledWhere) {
  // console.log('chatting connect', calledWhere)
  try {
    if (isReconnect === undefined || typeof isReconnect !== 'boolean') {
      isReconnect = false
    }
    if (use_browser_ws) {
      ws = new WebSocket(serverHost + ':' + wsPort + '/chat')
    }

    if (!not_disp_info) {
      printNotifyMessage('서버에 접속중입니다. ' + (use_browser_ws ? '[browser_ws]' : '[flash_ws]'))
    }
    ws.onopen = function () {
      if (window.chattingApp) {
        window.chattingApp.$store.dispatch('clearMessages')
      }
      if (!not_disp_info) {
        printNotifyMessage('서버와 접속되었습니다.')
      }
      loginUser(isReconnect)
    }

    ws.onmessage = function (e) {
      processData(e.data)
    }
    ws.onclose = function () {
      printErrorMessage('접속이 종료되었습니다.')
      if (is_login === true) {
        disconnect()
      }
      stopPingTimer()
    }
    ws.onerror = function (e) {
      // console.error('ws error', e)
    }

    if (!use_browser_ws) {
      ws.send = function (data) {
        thisMovie('livechat_client').sendToData(data)
      }

      ws.close = function () {
        thisMovie('livechat_client').disconnect()
      }
    }
  } catch (exception) {
    // printErrorMessage('connect Error ' + exception)
    // console.log('connect Error ' + exception)
  }
}

window.cheerConnect = function () {
  // console.log('chatting connect', calledWhere)
  try {
    if (use_browser_ws) {
      if (site_id === 'lottery') {
        ws_sub = new WebSocket(serverSubHost)
      }
    }

    ws_sub.onopen = function () {
      if (ws_sub && ws_sub.send) {
        var noSubscriptionTopic = Cookies.get('cheerFilter')
        // var subscriptionTopicList = ['soccer', 'baseball', 'basketball', 'volleyball', 'football', 'hockey', 'lol', 'star']
        var subscriptionTopicList = ['soccer', 'basketball', 'volleyball', 'football', 'hockey', 'baseball', 'lol', 'star']
          .filter(v => {
            if (noSubscriptionTopic) return !~noSubscriptionTopic.indexOf(v)
            else return true
          })
        subscriptionTopicList.forEach(topic => {
          ws_sub.send(`SUB sports.${topic}.cheers`)
        })
      }
    }

    ws_sub.onmessage = function (e) {
      if (site_id === 'localhost' && Cookies.get('cheerView') !== 'N') {
        CheersProcessData(e.data)
      }
    }
  } catch (exception) {
    // printErrorMessage('connect Error ' + exception)
    // console.log('connect Error ' + exception)
  }
}
window.login_success = function (version) {
  is_login = true
  is_login_success = true
  printNotifyMessage('[' + window.channel_name + '] 에 참여합니다.')

  for (var index in queue) {
    queueitem = queue[index]
  }
  join_lobby()
  Cookies.set('site_id', site_id, { path: '/', expires: 365 })
}

window.force_disconnect = function () {
  // console.log('chatting disconnect')
  window.is_login_success = false
  try {
    window.is_login = false
    ws.close()
  } catch (e) {
    // console.error('ws force_disconnect error', e)
  }
}

window.disconnect = function () {
  // console.log('chatting disconnect')
  if (is_login_success === true) {
    printErrorMessage('서버와 접속이 종료되었습니다.')
    window.max_reconnect_time += 5
    window.reconnect_yn = true
    printNotifyMessage(window.max_reconnect_time + '초후에 재접속합니다.')
    var timer = setInterval(function () {
      clearInterval(timer)
      reconnect()
    }, max_reconnect_time * 1000)
  }
}

window.reconnect = function () {
  // console.log('chatting reconnect')
  if (reconnect_yn) {
    if (use_browser_ws) {
      connect(true, true)
    } else {
      thisMovie('livechat_client').reconnect()
    }
  }
}

window.set_admin = function (status) {
  if (typeof status === 'boolean') {
    window.is_admin = status // status=> true || false
  }
}

window.sendToLobby = function (data) {
  if (!is_login) { // 접속중이 아닌 상태에서 로비에 들어갈 경우
    queue.push({'type': 'LOBBY', 'data': data})
    return
  }

  if (is_login === true) {
    var packet = {
      'header': {
        'version': '1.0',
        'type': 'LOBBY',
        'direction': 'server'
      },
      'body': data
    }
    ws.send(JSON.stringify(packet))
  } else {
    connect()
  }
}

window.adminCmd = function (op_cmd, target_userid, target_username) {
  var data = {
    'cmd': 'ADMIN',
    'op_cmd': op_cmd,
    'target_userid': target_userid,
    'target_username': target_username
  }
  sendToLobby(data)
}

window.join_lobby = function () {
  sendToLobby({
    'cmd': 'JOIN_LOBBY',
    'face_icon': face_icon,
    'user_status': user_status,
    'allow_whisper': allow_whisper,
    'allow_invite': allow_invite,
    'allow_date': allow_date,
    'user_agent': navigator.userAgent
  })
  startPingTimer()
}

window.pingTimer = null
window.startPingTimer = function () {
  if (pingTimer == null) {
    pingTimer = setInterval(sendPing, 1000 * 30)
  }
}

window.stopPingTimer = function () {
  if (pingTimer !== null) {
    clearInterval(pingTimer)
    pingTimer = null
  }
}

window.sendPing = function () {
  if (site_id === 'racing') {
    if (!is_admin) { // 관리자는 사라지지 않도록 함
      chatMessageArrange()
    }
  }
  sendToLobby({cmd: 'PING'})
}

window.loginUser = function (isReconnect) {
  var loginPacket = {
    'header': {
      'version': '1.1',
      'type': 'LOGIN',
      'direction': 'server'
    },
    'body': {
      'cmd': 'LOGIN_USER',
      'site_id': window.site_id,
      'userid': window.userid,
      'session_id': window.sessID,
      'connect_mode': window.connect_mode,
      'browser_type': window.device_type,
      'version': '1.1',
      'reconnect': (isReconnect === true ? 'Y' : 'N')
    }
  }
  if (ws) {
    ws.send(JSON.stringify(loginPacket))
  } else {
    if (is_login === false) {
      connect()
    }
  }
}

window.replaceImage = function (text) {
  var replacement = replaceURLWithHTMLLinks(text)
  return replacement
}

window.replaceURLWithHTMLLinks = function (text) {
  var exp = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig // eslint-disable-line
  var newUrl = ''

  if (window.top !== window.self && window.parent) {
    newUrl = text.replace(exp, function ($1) {
      var urlObj = parseUri($1)
      if (urlObj.host === 'ntry.com') {
        return $1
      } else if ((urlObj.host).indexOf('named.com') >= 0 && (urlObj.directory).indexOf('/nlivechat/') !== 0) {
        if (urlObj.anchor.indexOf('src') === 0 && urlObj.anchor.indexOf('named.com') > 0) {
          var thisEncodeURI = decodeURIComponent(urlObj.anchor)
          var thisSRC = decodeURIComponent(thisEncodeURI.split('=')[1])
          return replaceURLWithHTMLLinks(thisSRC)
        }
        return '<a href="' + urlObj.relative + '" target="mainFrame">' + $1 + '</a>'
      } else {
        return '<a href="javascript:;" onclick="window.open(\'/go.php?url=' + escape($1) + ', \'_blank\', \'width=1024,height=768, scrollbars=yes,toolbar=yes,location=yes,resizable=yes,status=yes,resizable=yes\' );return false;">' + $1 + '</a>'
      }
    })
  } else {
    newUrl = text.replace(exp, function ($1) {
      urlObj = parseUri($1)
      if (urlObj.host === 'ntry.com') {
        return $1
      } else {
        return '<a href="javascript:;" onclick="window.open(\'/go.php?url=' + escape($1) + ', \'_blank\', \'width=1024,height=768, scrollbars=yes,toolbar=yes,location=yes,resizable=yes,status=yes,resizable=yes\' );return false;">' + $1 + '</a>'
      }
    })
  }
  return newUrl
}

// 도배기준, 최근 보낸 5개의 메세지 텀의 합계가 5초보다 짧은 경우 도배금지 메세지 전송후
// 10초가 메세지 입력금지
window.is_dobae = false
window.last_msg_send_time = (new Date()).getTime() // 마지막으로 메세지 보낸시각
window.sum_msg_send_term = 0 // 최근 5개 메세지 발송시간 간격
window.msg_send_terms = []
window.msg_send_size = []
window.msg_term_idx = 0
window.msg_stop_time = 10 // 도배차단시간 10초

window.checkDobae = function (msg) {
  var result = 0 // 도배시간의 합계
  var result_size = 0 // 도배시간의 합계
  var tdate = new Date()

  msg_send_terms[msg_term_idx % 5] = tdate.getTime() - last_msg_send_time
  msg_send_size[msg_term_idx % 5] = msg.length
  last_msg_send_time = tdate.getTime()
  msg_term_idx++

  for (var i = 0; i < msg_send_terms.length; i++) {
    result += msg_send_terms[i]
    result_size += msg_send_size[i]
  }

  if (msg_send_terms.length === 5 && (result < 3 * 1000 || result_size > 300)) {
    is_dobae = true
    printErrorMessage('도배금지. ' + msg_stop_time + '초간 채팅이 금지됩니다.')
    setTimeout(clearDobae, msg_stop_time * 1000) // 10초가 도배금지
    return true
  } else {
    return false
  }
}

window.clearDobae = function () { // 도배 초기화
  msg_term_idx = 0
  msg_send_terms = []
  is_dobae = false
}

window.onunload = function () {
  try {
    is_login = false
    ws.close()
  } catch (e) {
    // console.error('window unload error', e)
  }
}

window.autoFreezer = null
window.useAutoFreezer = false
window.startAutoFreezer = function () {
  autoFreezer = setInterval(function () {
    var now = window.dateTime.getDate()
    var unixtimestamp = Math.floor(now.getTime() / 1000)
    var hour = now.getHours()
    var min = now.getMinutes()
    var sec = now.getSeconds()
    var nowtime = hour + ':' + min + ':' + sec
    // 사다리 시간과 정시는 10초 차이가 있음. 사다리가 10초 느림.
    if (unixtimestamp % 300 === 297) { // 57초에 얼림(사다리 기준 47초)
      if (window.is_freeze === false) { // 안얼려있는 경우에 얼림
        printNotifyMessage('현재시간 ' + nowtime)
        adminCmd('FREEZE_ROOM', '', '')
        var t = window.dateTime.getDate()
        var banner_img = (hour % 2 === 0) ? 'chat_app_banner01.png' : 'chat_app_banner02.png'
        var msg = "<a href='Intent://run#Intent;scheme=named;package=com.named.app;end' target='_blank' style='display:block; margin:-4px -6px; height:150px; text-align:center;'><img src='/img/app_down/" + banner_img + "?" + t.getTime() + "'></a>" // eslint-disable-line
        var data = {
          'cmd': 'ADMIN',
          'op_cmd': 'MSG',
          'target_site_id': 'game',
          'target_device': 'android',
          'msg': msg,
          'userid': userid,
          'username': username
        }
        if (min >= 0 && min < 5) { // 1시간에 한번씩만 보냄.
          sendToLobby(data)
        }
      }
    } else if (unixtimestamp % 300 === 10) { // 10초에 얼림 해제(사다리기준 00초)
      if (window.is_freeze === true) {
        printNotifyMessage('현재시간 ' + nowtime)
        adminCmd('MELT_ROOM', '', '')
      }
    }
  }, 1000)
}

window.stopAutoFreezer = function () {
  clearInterval(autoFreezer)
  autoFreezer = null
}

window.toggleAutoFreezer = function () {
  if (site_id === 'game') {
    if (useAutoFreezer) {
      useAutoFreezer = false
      stopAutoFreezer()
      printNotifyMessage('자동 얼리기를 중지합니다.')
    } else {
      useAutoFreezer = true
      startAutoFreezer()
      printNotifyMessage('자동 얼리기를 활성화 합니다.')
    }
  } else {
    printSystemMessage('자동 얼리기는 사다리 채팅에서만 사용가능합니다.')
  }
}

// parseUri 1.2.2
// (c) Steven Levithan <stevenlevithan.com>
// MIT License

window.parseUri = function (str) {
  var o = parseUri.options
  var m = o.parser[o.strictMode ? 'strict' : 'loose'].exec(str)
  var uri = {}
  var i = 14

  while (i--) uri[o.key[i]] = m[i] || ''

  uri[o.q.name] = {}
  uri[o.key[12]].replace(o.q.parser, function ($0, $1, $2) {
    if ($1) {
      uri[o.q.name][$1] = $2
    }
  })

  return uri
}

parseUri.options = {
  strictMode: false,
  key: ['source', 'protocol', 'authority', 'userInfo', 'user', 'password', 'host', 'port', 'relative', 'path', 'directory', 'file', 'query', 'anchor'],
  q: {
    name: 'queryKey',
    parser: /(?:^|&)([^&=]*)=?([^&]*)/g
  },
  parser: {
    strict: /^(?:([^:\/?#]+):)?(?:\/\/((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?))?((((?:[^?#\/]*\/)*)([^?#]*))(?:\?([^#]*))?(?:#(.*))?)/, // eslint-disable-line
    loose:  /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/ // eslint-disable-line
  }
}
/* ------------------------------ end legary code ------------------------------ */

window.processData = function (data) {
  try {
    if (JSON.parse(data).c) { // 채팅방을 이용하는 전체 인원수 패킷 처리
      user_count = JSON.parse(data).c
      if (typeof chattingApp !== 'undefined') {
        window.chattingApp.chatZoneArray[window.site_id].userCount = parseInt(user_count) + 10000
      }
      return
    }
    // TODO : replace를 하는 이유 ==> 태봉님? : 종훈님?
    data = data.replace("\"h\":{l}", "\"header\":{\"direction\":\"server\",\"type\":\"LOBBY\",\"version\":\"1.0\"}") // eslint-disable-line
    data = data.replace("\"{b:{c:m[\"", "{\"body\":{\"cmd\":\"MSG\",\"messages\":[") // eslint-disable-line
    // END TODO

    var packet = JSON.parse(data)

    var bodyPacket = packet.body
    var commend = packet.body.cmd
    var packetType = packet.header.type

    if (is_login === false) {
      if (commend === 'LOGIN_SUCCESS') {
        window.is_login = false
        login_success()
      } else if (commend === 'LOGIN_FAIL' && packetType === 'LOGIN') {
        window.is_login = false
      }
    }
    // processData
    (processDataMap[packetType] || console.warn)(bodyPacket, packet.header)
  } catch (e) {
    return
  }
}

var lastChatId
window.CheersProcessData = function (data) {
  if (data === 'OK') return
  try {
    var packet = JSON.parse(data)
    var packetMessage = JSON.parse(packet.MESSAGE)
    if (lastChatId !== packetMessage.id) {
      lastChatId = packetMessage.id
      printChatMessage(packetMessage.user_id, packetMessage.mb_nick, packetMessage.content, '', packetMessage.create_at, packetMessage.level, '', packetMessage)
    }
  } catch (e) {
    return
  }
}

window.processLogin = function (data) {
  try {
    var commend = data.cmd;
    (processLoginMap[commend] || console.warn)(data)
  } catch (e) {
    printErrorMessage('processLogin error : ' + e)
  }
}

// 채팅 메세지를 화면에 표시한다.
window.printChatMessage = function (send_id, send_username, msg, attribute, msg_time, exp_level, today_word, cheer_info, msg_point) {
  // console.log('printChatMessage', send_id, send_username, msg, attribute, msg_time, exp_level, today_word)
  // 블랙리스트로 등록된 사용자는 메세지 표시 안함
  if ((',' + black_users.join(',') + ',').indexOf(',' + send_id + ',') >= 0) { // 블랙리스트에 등록되어 있다면,
    return
  }
  if (msg.indexOf('<b>도배') >= 0) {
    // 20171120 추가: 도배 규정이 2개이상에서 1개이상 동일문구 입력시 유저한테만 보이지 않던 규정을 어드민도 보이지 않도록 하기 위해 조치함 (원상 복구를 편리하기 위해 @taebong.kim 님이 요청 by sukmin.lim)
    return
  }
  send_username = send_username.replace(/'/g, '')

  var att = attribute.split(',')
  var ico = ''
  var rank = ''
  var level = {
    1: '훈련병',
    2: '이등병',
    3: '일병',
    4: '상병',
    5: '병장',
    6: '하사',
    7: '중사',
    8: '상사',
    9: '원사',
    10: '소위',
    11: '중위',
    12: '대위',
    13: '소령(진)',
    14: '소령',
    15: '중령',
    16: '대령',
    17: '준장',
    18: '소장',
    19: '중장',
    20: '대장',
    21: '원수'
  }
  var vendorList = [
    '5ljxsv9n83f1f834e1228943899cbed0ce370aa9',
    'l3g4mv0fa09f8a4f06eef70a268ce28b38634a54',
    'hd9bwsko827e73806ce7721ce785f3e45fb3a188',
    '2k41r8ozdf0c0bc9f13d302d38d78eca4050e2eb',
    'hkdn8ecy6245085b21319e342eab975fc3afd377',
    '24m9gce3182e9ed28d6e13d59e6a2884395262b7',
    '91uqzywi0bf20bc6795179179752320b303182fa',
    'ukvqjars93c523ea1d6b0a05f94a2bd2fd3918a0',
    'ofa2bdmw61f1522e2d6400ba675459c8661d5336',
    'pvqfncz9fbbbfa6540db69a01e38ed15774f65e3',
    'ks1b8h9r93fb5752b1c955a7d942dcb46436ed08',
    'm2qo0j3gcd4f3d01d70dea2789c5a4f7890060d2',
    '7ue0qh1sf952a18fb2021503c74c343c57c9b220',
    'frx6c9736f005d0086c9ee6d3200a86507675b40',
    'il3c2zvn3d29dca31b22b37d53280a67c5776caa',
    'kgurnzvd6ae0646fb5e58398f7459685fbd3d021',
    'bdwe6ruj0321910f4d83c8b6668ba0557330f260',
    'cde6ptzib5a0fa3434171c5cb350bd561f500e00',
    'fgvsiek996fd07f6170f1253885bc38bbd5840ae',
    '8m7e6vh247d3863b8d3f3417cdc1b18430327201',
    '8ox5awhgd212fed0cc8bb0b6cedef10b96a0e1bd',
    '7s8eth5rb53f06e8f9913fe6a738d1c253c0f477',
    'szvod98a98c51d296cbfcd59414a361f66f0c6cc',
    'on0tb7wqc058516701df69694828c1023784cb0d',
    'k7r9pbidaa08859efec66dc22afa52920c06a2f0',
    'jhn7mal9041f6a3ed182b9ccf3b3ae985496cd38',
    '5dskhi2lb4e2d3784b47dd7eb2467e6cbd582481',
    'b78f09er66833cbc449b383ce487ff8bd0cd6ac4',
    'czilk3usa8f29e30801abe55f90f67cbbfe6c669',
    'gmvh5n2ra75eedda55479cf87ca9b9b299a531b4',
    'ydaxu6o11ff5786d6cb2a566d8fed96874efc81f',
    '0ep8fiul3be50c81d9f2d72e534c618929620a61',
    'cm0sdbyf60be4704a618f067901016698fe50a2d',
    'dbzvqe5wadec82ca0ac95e66c0f97f1c2cb78904',
    '46z9lot1466ab838bd49bc06e22586d30162ef34'
  ]

  // 영관, 장성급 계급 노출
  if (exp_level === 'mng') {
    ico = '/img/lv/24/mng.png'
    rank = 'high_rank'
  } else {
    var exp_level_num = Number(exp_level)

    if (exp_level_num >= 14) {
      ico = '/img/lv/24/' + exp_level_num + '.png'
      rank = 'high_rank'
    } else if (exp_level_num < 14) { // 영관급 : 계급만 노출
      if (vendorList.includes(send_id)) {
        ico = '/img/lv/18/99.png'
        rank = 'rank_medel'
      } else {
        ico = '/img/lv/18/' + exp_level_num + '.png'
        rank = 'rank_medel'
      }
    }
  }
  if (rank !== '') {
    att.push(rank)
  }

  if (send_id === userid) {
    att.push('mytalk')
  }

  if (msg.indexOf('<b>필터링') >= 0 || msg.indexOf('<b>도배') >= 0) {
    // admin만 볼수 있는 메시지이며
    // html형식을 다 가춰서 내려오기 떄문에 css 적용된 내용을 전부 풀어주었음.
    att = []
  }

  if (is_admin) {
    msg = msg + ' (' + msg_time + ')'
  }
  var messageProtocol = {
    'msg': msg,
    'msg_point': msg_point,
    'username': send_username,
    'userid': send_id,
    'style': att.join().replace(/,/g, ' '),
    'imgSrc': ico,
    'imgAlt': level[exp_level_num],
    'userRank': rank,
    'cheerInfo': cheer_info
  }
  // console.log('printChatMessage - addMessage', messageProtocol)
  if (typeof window.chattingApp !== 'undefined') {
    window.chattingApp.$store.dispatch('addMessage', messageProtocol)
  } else {
    console.log('chattingapp is not loaded', typeof chattingApp)
  }
}

window.chatMessageArrange = function () {
  if (typeof chattingApp !== 'undefined') {
    window.chattingApp.$store.dispatch('arrangeMessages')
  } else {
    console.log('chattingapp is not loaded', typeof chattingApp)
  }
}

window.purify_chatlog = function (target_userid) {
  if (typeof chattingApp !== 'undefined') {
    window.chattingApp.$store.dispatch('purifyMessages', target_userid)
  } else {
    console.log('chattingapp is not loaded', typeof chattingApp)
  }
}

window.printMessage = function (message, style, roomData) {
  if (style === undefined || typeof style !== 'string') {
    style = ''
  }
  if (roomData === undefined || typeof roomData !== 'object') {
    roomData = {}
  }
  var messageProtocol = {
    'msg': message.replace(/<br\/>/gi, ' '),
    'style': style,
    'roomUid': roomData.room_uid // 방체팅 링크 URL을 위한 Data
  }
  // console.log('printMessage - addMessage', messageProtocol)
  if (typeof window.chattingApp !== 'undefined') {
    window.chattingApp.$store.dispatch('addMessage', messageProtocol)
  } else {
    console.log('chattingapp is not loaded', typeof chattingApp)
  }
}

window.printErrorMessage = function (message) {
  window.printMessage(message, 'error')
}

window.printNotifyMessage = function (message, isEnterRoom, roomData) {
  var style = 'notify'
  if (isEnterRoom === true) {
    style += ' link'
  }
  window.printMessage(message, style, roomData)
}

window.printSystemMessage = function (message) {
  window.printMessage(message, 'system')
}

window.printWarningMessage = function (message) {
  window.printMessage(message, 'warning')
}

window.printPointMessage = function (message) {
  window.printMessage(message, 'point')
}

window.printSpecialNotiMessage = function (message) {
  window.printMessage(message, 'special_noti')
}
window.popMemo = function (uid) {
  window.newWindow('/memo/memo_form.php?me_recv_mb_id=' + uid, '_memo', 595, 485, 0, 0)
}

window.popRecvMemo = function () {
  window.newWindow('/memo/memo_recv.php', '_memo', 595, 535, 0, 0)
  document.querySelector('#popupLayout').style.display = 'none'
}

window.popRequestDate = function (target_site_id, target_userid, target_username) {
  window.privateChatWindow = window.open('./date.php?target_site_id=' + target_site_id + '&tuserid=' + target_userid + '&tname=' + target_username + '&mode=TEMP_DATE', 'private_chat' + target_userid, 'width=480, height=640, resizable=no, scrollbars=no, status=no;')
}

window.popRequestInvite = function (room_uid, target_userid) {
  var url = './pop_request_invite.php?room_uid=' + room_uid + '&target_userid=' + target_userid
  newWindow(url, '_' + room_uid, 424, 259, 0, 0)
}

window.goArticle = function (bo_table, wr_id) {
  if (parent && parent.mainFrame) {
    parent.mainFrame.location.href = '/bbs/board.php?bo_table=' + bo_table + '&wr_id=' + wr_id
  }
}

window.goItemShop = function () {
  if (parent && parent.mainFrame) {
    parent.mainFrame.location.href = '/market/itemshop/item_chat.php'
  }
}

window.whisper = function (uid) {
  alert(uid + '에게 귓속말하기 ')
}

window.newWindow = function (a_str_windowURL, a_str_windowName, a_int_windowWidth, a_int_windowHeight, a_bool_scrollbars, a_bool_resizable) {
  var int_windowLeft = (screen.width - a_int_windowWidth) / 2
  var int_windowTop = (screen.height - a_int_windowHeight) / 2
  var str_windowProperties = 'height=' + a_int_windowHeight + ',width=' + a_int_windowWidth + ',top=' + int_windowTop + ',left=' + int_windowLeft + ',scrollbars=' + a_bool_scrollbars + ',resizable=' + a_bool_resizable + ''
  var obj_window = window.open(a_str_windowURL, a_str_windowName, str_windowProperties)
  if (obj_window == null) {
    alert('차단된 팝업창을 허용해 주십시오.')
  } else if (parseInt(navigator.appVersion) >= 4) {
    obj_window.window.focus()
  }
}

window.requestDate = function (tuserid, tname) { // 1:1 대화를 신청을 한다.
  window.openDateWindow(site_id, tuserid, tname, 'REQ_DATE')
}

window.take_date = function (target_site_id, tuserid, tusername) { // 1:1 대화 수락
  var popupWindow = document.querySelector('#popupLayout')
  popupWindow.style.display = 'none'
  window.parent.postMessage('checkRoomChatReference', location.href)
  newPopRequestDateFunc.data = {
    target_site_id,
    tuserid,
    tusername
  }
}

window.reject_date = function (target_site_id, target_userid) { // 1:1 대화 거절
  var popupWindow = document.querySelector('#popupLayout')
  popupWindow.style.display = 'none'
  var data = {
    'cmd': 'REJECT',
    'type': 'DATE',
    'target_site_id': target_site_id,
    'target_userid': target_userid
  }
  sendToLobby(data)
}

window.openDateWindow = function (target_site_id, tuserid, tname, mode) {
  var url = './date.php?target_site_id=' + target_site_id + '&tuserid=' + tuserid + '&tname=' + tname + '&mode=' + mode

  if (window.privateChatWindow) {
    privateChatWindow.focus()
  } else {
    newWindow(url, 'private_chat' + tuserid, 400, 640, 0, 0)
  }
}

window.toggleSelctBox = function (o) {
  o.find('div.options').toggle()
  o.find('a.basic').toggleClass('on')
}

window.closeSelectBox = function (o) {
  o.find('div.options').hide()
  o.find('a.basic').removeClass('on')
}

// 셀렉트박스
window.inputOptionHandler = function (e) {
  // $target = $(e.target).closest("a");
  // closeSelectBox($("#foot a.basic").not($target).closest(".selectboxWrap"));
  // toggleSelctBox($target.closest(".selectboxWrap"));
  e.stopPropagation()
}

window.hidePopupLayer = function () {
  document.getElementById('popupLayout').style.display = 'none'
}

window.processLoginMap = {
  'LOGIN_FAIL': function (data) {
    is_login = false
    printSystemMessage('로그인에 실패했습니다.')
  },
  'ERROR': function (data) {
    var commend = data.type
    is_login = false
    try {
      processLoginErrorMap[commend]()
    } catch (e) {
      printErrorMessage('접속이 종료되었습니다.')
    }
  },
  'LOGIN_SUCCESS': function (data) {}
}

window.processLoginErrorMap = {
  'LOGIN_DUPLICATE': function () {
    window.is_login_success = false
    printSystemMessage('중복로그인으로 이전접속을 종료합니다.')
  },
  'NOT_EXIST_CHANNEL': function () {
    window.is_login_success = false
    printSystemMessage('존재하지 않은 채널입니다.')
  },
  'FIRST_MODE_CONNECTED': function () {
    window.is_login_success = false
    printSystemMessage('다른창에 접속되어 있습니다.')
  },
  'DISCONNECTED': function () {
    printSystemMessage('접속이 종료되었습니다.')
  },
  'SECURITY_KEY_NOT_MATCHED': function () {
    window.is_login_success = false
    printSystemMessage('패킷 암호화 오류. 다시 로그인 하세요.')
  },
  'SESSION_NOT_STORED': function () {
    window.is_login_success = false
    printSystemMessage('세션 오류. 다시 로그인 하세요.')
  },
  'SESSION_DATA_INVALID': function () {
    window.is_login_success = false
    printSystemMessage('세션 데이타 오류. 새로고침 후 다시 로그인 하세요.')
  },
  'CRIME_USER_NEED_RELOGIN': function () {
    window.is_login_success = false
    printSystemMessage('전과로 인해 일시적으로 접속이 제한 됩니다. 재로그인후 이용바랍니다.')
  }

}

window.processLobbyMap = {
  'PONG': function (data) {},
  'MSG': function (data) {
    for (var index in data.messages) {
      var message = data.messages[index]
      var style = message.style ? message.style : ''
      var disp_time = new Date(message.time).toString().substring(16, 24)
      var msgText = message.msg
      if (message.html === '1') msgText = message.msg // message.html? ==> 문의 할것
      window.printChatMessage(message.userid, message.username, msgText, style, disp_time, message.exp_level, message.today_word, '', message.msg_point)
      window.chattingLoadComplete = true
    }
  },
  'PRECHAT_MSG': function (data) {
    window.chattingLoadComplete = false
    for (var index in data.messages) {
      var message = data.messages[index]
      var style = message.style ? message.style : ''
      var disp_time = new Date(message.time).toString().substring(16, 24)
      var msgText = message.msg
      window.printChatMessage(message.userid, message.username, msgText, style, disp_time, message.exp_level, message.today_word, '', message.msg_point)
    }
    if (is_prisoner) {
      printSystemMessage('전과로 인해 ' + released_date + '일부터 채팅에 참여할수 있습니다.')
    }
  },
  'JOIN_LOBBY_USER': function (data) {
    user_count++
    window.chattingApp.chatZoneArray[site_id].userCount = data.user_count
  },
  'EXIT_LOBBY_USER': function (data) {
    user_count--
    window.chattingApp.chatZoneArray[site_id].userCount = data.user_count
  },
  'ADD_PLOBBY_USER': function (data) { /* nothing */ },
  'USER_COUNT': function (data) {
    user_count = data.user_count
    window.chattingApp.chatZoneArray[site_id].userCount = data.user_count
  },
  'CUC': function (data) {
    var channel_info = data.info
    window.chattingApp.chatZoneArray['racing'].userCount = parseInt(channel_info[2])
    window.chattingApp.chatZoneArray['localhost'].userCount = parseInt(channel_info[0])
    window.chattingApp.chatZoneArray['fxgame'].userCount = parseInt(channel_info[3])
    window.chattingApp.chatZoneArray['lottery'].userCount = parseInt(channel_info[4])
    // window.chattingApp.chatZoneArray['esport'].userCount = parseInt(channel_info[4])
    // window.chattingApp.chatZoneArray['game'].userCount = parseInt(channel_info[1])
    // window.chattingApp.chatZoneArray['rooms'].userCount = parseInt(channel_info[3])
  },
  'CREATE_ROOM_INFO': function (data) {
    if (data.room_info.noti_msg) {
      printWarningMessage(data.room_info.noti_msg)
    }

    printNotifyMessage(data.room_info.opener_name + '님이 새로운 방을 개설하였습니다. ')

    printNotifyMessage(data.room_info.title, true, data.room_info)

    if (data.room_info.noti_msg) {
      printWarningMessage(data.room_info.noti_msg)
    }

    if (window.top !== window.self && window.parent) {
      // parent.addRoomSticker(data.room_info);
    }
  },
  'MODIFY_ROOM_INFO': function (data) { var room_info = data.room_info },
  'CLOSE_ROOM': function (data) {
    if (window.top !== window.self && window.parent) {
      parent.removeRoomSticker(data.room_info.room_uid)
    }
  },
  'NOTICE': function (data) {
    var notice_type = data.notice.notice_type;
    (processLobbyNoticeMap[notice_type] || console.warn)(data)
  },
  'GIFT': function (data) {
    var action = data.action
    var send_id = data.data.mb_id
    var send_nm = data.data.mb_nick
    var gift_msg = data.extra.gift_msg
    if (action === 'GIFT_POINT' && gift_point >= 5000) {
      var room_title = data.room_info.title
      var opener_name = data.extra.opener_name
      var gift_point = data.extra.gift_point

      printPointMessage('[' + room_title + ']' + send_nm + '님께서 포인트 ' + parseInt(gift_point).toLocaleString() + '점을 ' + opener_name + '님에게 선물하셨습니다.')

      if (window.top !== window.self && window.parent) {
        parent.roomEvent(data.room_info.room_uid)
      }
    } else if (action === 'EVENT_ITEM') {
      var item_name = data.extra.item_name
      printPointMessage('이벤트 상품으로 [상품 ' + item_name + ']을 선물로 발송')
    }
  },
  'COMMON_NOTIFY': function (data) {
    var board_data = data.data
    var action = data.action
    var mb_id = board_data.mb_id
    var mb_nick = board_data.mb_nick
    var msg = data.msg
    var bo_table = board_data.bo_table
    var wr_id = board_data.wr_id
    if (data.type === 'BOARD') {
      if (action === 'COMMENT_WRITE') {
        var fk = data.extra.fk
        var rel = data.extra.rel

        if (window.top !== window.self && window.parent) {
          parent.callNotify(action, bo_table, wr_id, msg, fk)
        }
      } else if (action === 'GIFT_ITEM') {
        var fk = data.extra.fk // eslint-disable-line
        var rel = data.extra.rel // eslint-disable-line

        if (window.top !== window.self && window.parent) {
          parent.callNotify(action, bo_table, wr_id, msg, fk)
        }
      } else if (action === 'BOARD_VIEW') {
        // nothing
      } else if (action === 'COMMENT_REPLY') {
        parent.callCommonNotify(data)
      } else if (action === 'PRIVATE_CHAT') {
        parent.callCommonNotify(data)
      }
    } else if (data.type === 'MEMO') {
      var extra = data.extra
      var memo_reward_type = extra.memo_reward_type
      if (action === 'SEND_MEMO') {
        var me_id = extra.me_id
        var notifyFK = extra.notifyFK
        var inviteMsg = ''
        if (memo_reward_type === 'POINT') {
          inviteMsg = '<p><strong>랜덤 포인트 쪽지</strong>가 도착했습니다.</p>'
          printNotifyMessage('<strong>랜덤 포인트 쪽지</strong>가 도착했습니다.')
        } else if (memo_reward_type === 'EXP') {
          inviteMsg = '<p><strong>랜덤 경험치 쪽지</strong>가 도착했습니다.</p>'
          printNotifyMessage('<strong>랜덤 경험치 쪽지</strong>가 도착했습니다.')
        } else if (memo_reward_type === 'ITEM') {
          inviteMsg = '<p><strong>랜덤 아이탬 쪽지</strong>가 도착했습니다.</p>'
          printNotifyMessage('<strong>랜덤 아이탬 쪽지</strong>가 도착했습니다.')
        } else {
          inviteMsg = '<p><strong>' + mb_nick + '</strong>님이 쪽지를 보내셨습니다.</p>'
          printNotifyMessage(mb_nick + '님이 쪽지를 보내셨습니다.')
        }

        inviteMsg += '<div class="btn_area">&nbsp;<a id="take_date" class="btn_ok" href="javascript:;" onclick="popRecvMemo();" title="지금확인">지금확인</a><a id="reject_date" class="btn_no" href="javascript:;" onclick="document.querySelector(\'#popupLayout\').style.display = \'none\';" title="나중에확인">나중에확인</a>&nbsp;</div>'
        var popupWindow = document.querySelector('#popupLayout')
        popupWindow.childNodes[0].innerHTML = inviteMsg
        popupWindow.style.display = 'block'
        setTimeout(function () {
          popupWindow.style.display = 'none'
        }, 10000)

        if (window.top !== window.self && window.parent) {
          parent.callNotify(action, '', me_id, msg, notifyFK)
        }
      } else if (action === 'NOT_ALLOW_MSG') {
        printWarningMessage('포인트 부족으로 채팅이 금지되었습니다.')
      }
    } else if (data.type === 'ABUSE') {
      var target_userid = data.target_userid
      var target_username = data.target_username
      // 전과/경고가 부여된 사용자의 메세지만 삭제처리한다. 관리자 예외
      if (is_admin !== true) {
        purify_chatlog(target_userid)
      }
      if (data.action === 'GIVE_WARNING') {
        if (target_userid === window.userid) {
          var warning_count = data.extra.warning_count
          printWarningMessage('회원님에게 경고 벌점이 부여되었습니다. 포인트가 하락되며, 5분간 채팅에 참여할 수 없습니다. 누적 경고 횟수 3회 이상 시 전과 벌점이 부여되니 주의 바랍니다.')
          printWarningMessage('경고사유 : ' + data.msg + ' <a href="/bbs/board.php?bo_table=notice&wr_id=5044" target="mainFrame">벌점안내보기</a>' + ', 누적 경고 횟수 : ' + warning_count + '회')
          alert('회원님에게 경고 벌점이 부여되었습니다. 포인트와 경험치가 하락하며, 누적 경고 횟수 3회 이상 시 전과 벌점이 부여되니 주의 바랍니다. \n경고사유 : ' + data.msg + '\n누적 경고 횟수 : ' + warning_count + '회')
        } else {
          printWarningMessage(target_username + '님이 경고 처리되었습니다.(' + data.msg + ')')
        }
      } else if (data.action === 'GIVE_CRIME') {
        var crime_msg = (data.extra.crime_msg === undefined) ? '' : '' + data.extra.crime_msg + ' '
        if (target_userid === window.userid) {
          printSystemMessage('회원님에게 ' + crime_msg + '전과 벌점이 부여되었습니다. 포인트 차감 및 사이트내 활동이 제한됩니다.')
          is_login = false
          force_disconnect()
          alert('회원님에게 ' + crime_msg + '전과 벌점이 부여되었습니다. 포인트 차감 및 사이트내 활동이 제한됩니다.')
          location.reload()
          // is_login = false;
        } else {
          printSystemMessage(target_username + '님이 ' + crime_msg + '전과 처리되었습니다.(' + data.msg + ')')
        }
      }
    } else if (data.type === 'FRIEND') {
      if (data.action === 'FRIEND_LOGIN') {
        printNotifyMessage('친구 ' + mb_nick + '님이 로그인하였습니다.')
      } else if (data.action === 'FRIEND_ADD') {
        printNotifyMessage(mb_nick + '님이 당신을 친구로 추가하였습니다.')
      } else if (data.action === 'BAD_ADD') {
        black_users.push(mb_id)
      }
    } else if (data.type === 'ROOM_RANKING') {
      if (data.action === 'RANK12') {

      } else if (data.action === 'RANK_RELOAD') {
        if (parent !== window) {
          window.parent.chatRankReload()
        }
      }
    }
  },
  'INVITE': function (data) {
    /* eslint-disable */
    if (data.invite_type === 'DATE') {
      newInviteFunc.date = data;
      window.parent.postMessage('checkRoomChatReference', location.href);
      newPopRequestDateFunc.data = {
          target_site_id: data.target_site_id,
          tuserid: data.target_userid,
          tusername: data.target_username
      }
    } else if (data.invite_type == 'ROOM') {
      const selectedValueInConfingArray = (JSON.parse(Cookies.get('new_chat_config'))[1].values).filter(item => item.selected)[0].name;

      if (selectedValueInConfingArray !== '허용안함') {
        // 모두, 친구만 일때
        printNotifyMessage(data.room_title + " 방으로 부터 초대가 수신되었습니다.");
        popRequestInvite(data.room_uid, data.target_userid);
      }
    }
      /* eslint-disable */
   },
  'ERROR': function (data) {
    var error_type = data.type;
    (processLobbyErrorMap[error_type] || console.warn)(data)
  }
}

window.processLobbyNoticeMap = {
  'SET OPER': function () {
    set_admin(true);
    printNotifyMessage("방장으로 설정되었습니다.");
    printNotifyMessage("관리 명령어 사용가능.");
  },
  'BAN': function () {
    printErrorMessage("관리자에 의해 접속 차단되었습니다.")
  },
  'BAN USER': function () {
    printErrorMessage("접속차단된 아이디 또는 아이피입니다.")
  },
  'UNSET SILENT': function () {
    printNotifyMessage("채팅금지가 해제되었습니다.")
  },
  'SET SILENT': function (data) {
    printErrorMessage(data.notice.target_username + "님은 지금부터 채팅금지입니다.")
  },
  'SILENT': function (data) {
    var out_time = parseInt(data.notice.out_time)
    var remain_time = Math.floor(out_time / 60) + "분 " + (out_time % 60) + "초 남았습니다."
    printNotifyMessage("채팅금지 상태입니다. " + remain_time)
  },
  'USER INFO': function () {},
  'MSG': function (data) {
    if (data.notice.msg_body.indexOf("run#Intent") >= 0) { //app link
      var isAndroid = /(android)/i.test(navigator.userAgent)
      if (isAndroid) {
        printMessage(data.notice.msg_body)
      }
    } else {
      var msg = replaceImage(data.notice.msg_body)
      printErrorMessage(msg);
    }
  },
  'ANONCE': function () {
    printErrorMessage("[공지] " + data.notice.msg_body)
  },
  'SCHEDULE_MSG': function () {
    printNotifyMessage("{공지} " + data.notice.msg_body)
  },
  'INTRO': function () {
    printNotifyMessage("[소개] " + data.notice.msg_body)
  },
  'ERROR': function () {
    printErrorMessage(s2) // TODO: "s2" 문의 요망
  },
  'NO OP': function () {
    set_admin(false)
    printErrorMessage("방장권한이 없습니다.")
  },
  'NO CMD': function () {
    printErrorMessage("사용할수 없는 명령어입니다.")
  },
  'BANLIST': function () {
    alert(s2)
  },
  'CLEAR': function () {
    window.chattingApp.$store.dispatch('clearMessages')
    printNotifyMessage("채팅 내역이 초기화 되었습니다.")
    chatlog = [];
  },
  'SET FREEZE': function () {
    is_freeze = true;
    printErrorMessage("관리자가 채팅방을 얼렸습니다. 개인 채팅이 금지됩니다.")
  },
  'SET MELT': function () {
    is_freeze = false;
    printErrorMessage("관리자가 방을 녹였습니다. 이제 채팅이 가능합니다.");
  },
  'FREEZE_ROOM': function () {
    is_freeze = true;
    printNotifyMessage("관리자가 채팅방을 얼렸습니다. 개인 채팅이 금지됩니다.");
  },
  'BLOCK_PC': function () {
    var value = data.notice.value;
    Cookies.set("block_pc", value, {
      path: "/nlivechat",
      expires: 1
    });
  },
  'CLEAR_CHAT_LOG': function () {
    if (is_admin != true) {
      // 전과/경고가 부여된 사용자의 메세지만 삭제처리한다. 관리자 예외?>
      window.chattingApp.$store.dispatch('purifyMessages', data.notice.target_userid);
    }
  }
}

window.processLobbyErrorMap = {
  'GUEST_NOT_ALLOW': function () {
    alert("손님은 채팅에 참여할 수 없습니다.")
  },
  'ALREADY_CREATE_ROOM': function () {
    alert("이미 개설한 채팅방이 있습니다. 방을 1개만 개설할수 있습니다.")
  },
  'ALREADY_JOIN_ROOM': function () {
    alert("이미 참여중인 채팅방입니다. 중복으로 입장하실수 없습니다.")
  },
  'BAN_USER': function () {
    alert("강제퇴장된 방입니다. 접속이 금지됩니다.")
  },
  'JOIN_FAIL': function () {
    alert("채팅방에 입장할수 없습니다. 새로고침후 재시도 하세요.");
  },
  'EXCEED_MAX_USER': function () {
    alert("채팅방에 빈 자리가 없습니다.");
  },
  'NOT_EXIST_ROOM': function () {
    alert("개설되지 않았거나, 채팅이 종료된 방입니다.");
  },
  'REQUIRED_PASSWORD': function (data) {
    alert("비밀방은 새창으로만 입장하실수 있습니다.");
    openRoomChatWindow(data.room_uid);
  },
  'INCORRECT_PASSWORD': function () {}
}

window.processLobbyMapNew = {
  'ABUSE': function (body) {
    var chatroom = body.channel_id
    var commend = body.cmd
    var action = body.action
    var userID = body.data.target_userid
    var username = body.data.target_username
    var message = body.data.msg
    // 전과/경고가 부여된 사용자의 메세지만 삭제처리한다. 관리자 예외
    if (is_admin !== true) {
      purify_chatlog(userID)
    }
    switch (action) {
      case 'GIVE_WARNING':
        if (userID === window.userid) {
          var warningCount = data.warning_count
          printWarningMessage('회원님에게 경고 벌점이 부여되었습니다. 포인트가 하락되며, 5분간 채팅에 참여할 수 없습니다. 누적 경고 횟수 3회 이상 시 전과 벌점이 부여되니 주의 바랍니다.')
          printWarningMessage('경고사유 : ' + message + ' <a href="/bbs/board.php?bo_table=notice&wr_id=5044" target="mainFrame">벌점안내보기</a>' + ', 누적 경고 횟수 : ' + warningCount + '회')
          alert('회원님에게 경고 벌점이 부여되었습니다. 포인트와 경험치가 하락하며, 누적 경고 횟수 3회 이상 시 전과 벌점이 부여되니 주의 바랍니다. \n경고사유 : ' + message + '\n누적 경고 횟수 : ' + warningCount + '회')
        } else {
          printWarningMessage(username + '님이 경고 처리되었습니다.(' + message + ')')
        }
        break;
      case 'GIVE_CRIME':
        var crimeMessage = (data.extra.crime_msg === undefined) ? '' : '' + data.extra.crime_msg + ' '
        if (target_userid === window.userid) {
          printSystemMessage('회원님에게 ' + crimeMessage + '전과 벌점이 부여되었습니다. 포인트 차감 및 사이트내 활동이 제한됩니다.')
          is_login = false
          force_disconnect()
          alert('회원님에게 ' + crimeMessage + '전과 벌점이 부여되었습니다. 포인트 차감 및 사이트내 활동이 제한됩니다.')
          location.reload()
          // is_login = false;
        } else {
          printSystemMessage(username + '님이 ' + crimeMessage + '전과 처리되었습니다.(' + message + ')')
        }
        break;
    }
  },
  'NOTIFICATION': function (body) {
    var chatroom = body.channel_id
    var commend = body.cmd
    var action = body.sub_type
    var message = body.data.message
    var itemName = body.data.extra

    if (itemName !== undefined && itemName !== null && (message.indexOf('{{ item }}') >= 0) ) {
      message = message.replace('{{ item }}', '<b>' + itemName + '</b>')
    }
    switch (action) {
      case 'ITEM':
        printSpecialNotiMessage(message)
        break
    }
  }
}


window.processLobby = function (data, header) {
  try {
    if (header.version === '1.2') {
      (processLobbyMapNew[data.cmd] || console.warn)(data)
    } else {
      (processLobbyMap[data.cmd] || console.warn)(data)
    }
  } catch (e) {
    // console.error('processLobby error', e)
  }

}

window.processDataMap = {
  'LOGIN': processLogin,
  'LOBBY': processLobby,
  // 'ROOM': processRoom,
  // 'DATE': processDate,
  // 'SYSTEM': processSystem
}
window.onload = function () {
  // start chatting app
  if (!is_allow_guest && member_no === '') {
    printNotifyMessage('손님은 로그인후 채팅에 참여할수 있습니다.')
    return false
  }

  if (use_browser_ws) {
    if (navigator.userAgent.indexOf('MSIE') < 0) {
      if (window.ws.onclose === undefined) {
        connect()
        cheerConnect()
      }
    }
  }
}



function newInviteFunc () {
  const popupWindow = document.getElementById('popupLayout')
  const inviteMsg = `
    <p><strong>${newInviteFunc.date.target_username}</strong>님이 1:1 대화를 요청하셨습니다.</p>
    <div class="btn_area">
      <a id='take_date' class="btn_ok" href="javascript:take_date('${newInviteFunc.date.target_site_id}', '${newInviteFunc.date.target_userid}', '${newInviteFunc.date.target_username}');">수락</a>
      <a id='reject_date' class="btn_no" href="javascript:reject_date('${newInviteFunc.date.target_site_id}', '${newInviteFunc.date.target_userid}');">거절</a>
    </div>`;

  popupWindow.firstElementChild.innerHTML = inviteMsg;
  popupWindow.style.display = 'block';
  setTimeout(() => { popupWindow.style.display = 'none';}, 10000);
  printNotifyMessage(newInviteFunc.date.target_username + "님으로 부터 1:1 초대가 수신되었습니다.");
}

function newPopRequestDateFunc () {
  window.privateChatWindow = window.open('./date.php?target_site_id=' + newPopRequestDateFunc.data.target_site_id + '&tuserid=' + newPopRequestDateFunc.data.tuserid + '&tname=' + newPopRequestDateFunc.data.tusername + '&mode=TEMP_DATE', 'private_chat' + newPopRequestDateFunc.data.tuserid, 'width=480, height=640, resizable=no, scrollbars=no, status=no;');
}

/* ------------------------------ legary code ------------------------------ */
/* ------------------------------    [END]    ------------------------------ */

// init Vue APP

Vue.config.productionTip = false

Vue.use(Router)

const router = new Router({
  routes
})

/* eslint-disable no-new */
if (navigator.userAgent.indexOf('MSIE') < 0) {
  window.vm = new Vue({
    router,
    el: '#chattingAPP',
    template: '<App/>',
    components: { App }
  })

  window.chattingApp = window.vm.$children[0]
}
window.chattingLoadComplete = false

window.addEventListener('message', (event) => {
  if (event.data && event.data.hasOwnProperty('hasRoomChatReference') && event.origin === location.origin) {
    // 방채팅 열람 이력에 관한 포스트 메세지를 받았다면
    if (!event.data.hasRoomChatReference) {
      // 방채팅을 오픈한 참조값이 없을때 1:1 채팅 자동 팝업을 띄우고
      newPopRequestDateFunc();

      if (!window.privateChatWindow) {
        // 팝업 차단으로 인해 1:1 채팅 자동 팝업이 정상적으로 열리지 못했다면 토스트 팝업을 띄움
        newInviteFunc();
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js